"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = exports.InputWrapper = exports.InputBaseWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var InputBaseWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", ";\n\t", ";\n\tfont-family: 'Roboto';\n\tfont-size: 16px;\n\tfont-stretch: normal;\n\tfont-style: normal;\n\tletter-spacing: normal;\n\tfont-weight: 500;\n"])), _styledSystem.space, _styledSystem.layout);
exports.InputBaseWrapper = InputBaseWrapper;
var InputWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tborder-bottom: 0.6px solid ", ";\n\tpadding: 6px 0;\n\tborder-bottom-color: ", ";\n"])), function (props) {
  return props.theme.colors.silver;
}, function (props) {
  return props.error ? props.theme.colors.princetonOrange : '';
});
exports.InputWrapper = InputWrapper;
var StyledInput = _styledComponents["default"].input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tflex: 1;\n\twidth: 100%;\n\tborder: none;\n\tfont: inherit;\n\t--color: ", ";\n\toutline: var(--color);\n\tfont-size: 10px;\n\n\t&::placeholder {\n\t\tcolor: var(--color);\n\t}\n\t", "\n\t", ";\n\t", "\n"])), function (props) {
  return props.theme.colors.silver;
}, function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.mediaQueries.medium, "{\n\t\tfont-size : 16px;\n\t}");
}, _styledSystem.background, (0, _styledSystem.variant)({
  prop: 'background',
  scale: 'backgrounds'
}));
exports.StyledInput = StyledInput;